<CPF-contract-claims-list [claims]="claims" [showSelectButton]="true" (claimSelected)="claimSelected($event)"></CPF-contract-claims-list>
